import { compose } from '@reduxjs/toolkit';
import { withTranslation } from 'react-i18next';

import CardTypeTag from './CardTypeTag.layout';


const decorate = compose(withTranslation('transactions'));

export default decorate(CardTypeTag);
